<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 5H20" stroke="#697B8E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M14 8H17" stroke="#697B8E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M21 11.5C21 16.75 16.75 21 11.5 21C6.25 21 2 16.75 2 11.5C2 6.25 6.25 2 11.5 2" stroke="#697B8E"
      stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M22 22L20 20" stroke="#697B8E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>

</template>